import cn from 'classnames';

const OfficeFilter = ({ offices, handleOfficeChange, selectedOffice, departmentFilter }) => (
  <div className="relative">
    <select
      className={cn(
        'w-full p-2 pr-24 border rounded-lg outline-none border-neutral-200 md:min-w-48 md:w-fit',
        { 'cursor-not-allowed opacity-50': departmentFilter === '' }
      )}
      name="office-select"
      id="office-select"
      onChange={handleOfficeChange}
      value={selectedOffice}
      disabled={departmentFilter === ''}
    >
      <option value="">All Locations</option>
      {offices.map(office => (
        <option key={office.id} value={office.name}>
          {office.name}
        </option>
      ))}
    </select>
  </div>
);

export default OfficeFilter;
